import type { DataResponse, PaginatedResponse, User } from "@/types";
import { api } from "../api";

export const userService = {
  list: (params?: { page?: number; pageSize?: number; search?: string; includeInactive?: boolean }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.pageSize) searchParams.set("page_size", String(params.pageSize));
    if (params?.search) searchParams.set("search", params.search);
    if (params?.includeInactive !== undefined) searchParams.set("include_inactive", String(params.includeInactive));
    return api.get<PaginatedResponse<User>>(`/admin/users?${searchParams}`);
  },
  get: (userId: string) => api.get<DataResponse<User>>(`/admin/users/${userId}`),
  create: (data: { email: string; name: string; role?: string; team_uuids?: string[] }) =>
    api.post<DataResponse<User>>("/admin/users", data),
  update: (userId: string, params: { role?: string; is_active?: boolean; deactivation_reason?: string }) => {
    const searchParams = new URLSearchParams();
    if (params.role) searchParams.set("role", params.role);
    if (params.is_active !== undefined) searchParams.set("is_active", String(params.is_active));
    if (params.deactivation_reason) searchParams.set("deactivation_reason", params.deactivation_reason);
    return api.put<DataResponse<User>>(`/admin/users/${userId}?${searchParams}`);
  },
  delete: (userId: string) => api.delete<{ message: string }>(`/admin/users/${userId}`),
};
